__turbopack_context__.v({
  "avatarOption": "EditProfileModal-module__bbJCKq__avatarOption",
  "avatarOptions": "EditProfileModal-module__bbJCKq__avatarOptions",
  "avatarSelection": "EditProfileModal-module__bbJCKq__avatarSelection",
  "closeButton": "EditProfileModal-module__bbJCKq__closeButton",
  "currentAvatar": "EditProfileModal-module__bbJCKq__currentAvatar",
  "editProfileContainer": "EditProfileModal-module__bbJCKq__editProfileContainer",
  "editProfileHeader": "EditProfileModal-module__bbJCKq__editProfileHeader",
  "errorMessage": "EditProfileModal-module__bbJCKq__errorMessage",
  "form": "EditProfileModal-module__bbJCKq__form",
  "formField": "EditProfileModal-module__bbJCKq__formField",
  "formHeader": "EditProfileModal-module__bbJCKq__formHeader",
  "formHeaderTitle": "EditProfileModal-module__bbJCKq__formHeaderTitle",
  "formIcon": "EditProfileModal-module__bbJCKq__formIcon",
  "formInput": "EditProfileModal-module__bbJCKq__formInput",
  "formLabel": "EditProfileModal-module__bbJCKq__formLabel",
  "icon": "EditProfileModal-module__bbJCKq__icon",
  "inputUsername": "EditProfileModal-module__bbJCKq__inputUsername",
  "selectedAvatarOption": "EditProfileModal-module__bbJCKq__selectedAvatarOption",
  "selectedFileName": "EditProfileModal-module__bbJCKq__selectedFileName",
  "trashButton": "EditProfileModal-module__bbJCKq__trashButton",
  "trashIcon": "EditProfileModal-module__bbJCKq__trashIcon",
});
